(function($, window, document, undefined) {
    $.fn.visible = function(partial) {
        if (!$(this).offset())
            return true;
        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;
        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };
    var pluginName = "finalTilesLayout",
        defaults = {
            layout: 'final',
            columns: [
                [4000, 5],
                [1024, 4],
                [800, 3],
                [480, 2],
                [320, 1]
            ],
            rowHeight: 200,
            margin: 10,
            minTileWidth: 200,
            ignoreImageAttributes: true,
            imageSizeFactor: [
                [4000, .9],
                [1024, .8],
                [800, .7],
                [600, .6],
                [480, .5],
                [320, .3]
            ],
            gridSize: 10,
            disableGridSizeBelow: 800,
            allowEnlargement: true,
            autoLoadURL: null,
            wrapperSelector: '.ftg-items',
            itemSelector: '.tiles',
            onComplete: function() {},
            onUpdate: function() {},
            onLoading: function() {},
            debug: false
        };
    function Plugin(element, options) { /*!properties*/
        this.element = element;
        this.$element = $(element);
        this.settings = $.extend({}, defaults, options);
        this._columnSize = 0;
        this._defaults = defaults;
        this._name = pluginName;
        this.tiles = [];
        this._loadedImages = 0;
        this._rows = [
            []
        ];
        this._currentRow = 0;
        this._currentRowTile = 0;
        this.edges = [];
        this.imagesData = {};
        this.currentWidth = 0;
        this.currentImageSizeFactor = 1;
        this.currentColumnsCount = 0;
        this.currentGridSize = 0;
        this.ajaxComplete = false;
        this.isLoading = false;
        this.currentPage = 1;
        this.init();
    }
    $.extend(Plugin.prototype, {

        setCurrentImageSizeFactor: function() {
            this.currentImageSizeFactor = 1;
            var ww = $(window).width();
            for (var i = 0; i < this.settings.imageSizeFactor.length; i++) {
                if (this.settings.imageSizeFactor[i][0] >= ww)
                    this.currentImageSizeFactor = this.settings.imageSizeFactor[i][1];
            }
            if (!this.currentImageSizeFactor)
                this.currentImageSizeFactor = 1;
        },
        setCurrentColumnSize: function() {
            var ww = $(window).width();
            for (var i = 0; i < this.settings.columns.length; i++) {
                if (this.settings.columns[i][0] >= ww)
                    this.currentColumnsCount = this.settings.columns[i][1];
            }
            this._columnSize = Math.floor((this.currentWidth - (this.settings.margin * (this.currentColumnsCount - 1))) / this.currentColumnsCount);
        },
        setCurrentGridSize: function() {
            if (this.currentWidth < this.settings.disableGridSizeBelow)
                this.currentGridSize = 0;
            else
                this.currentGridSize = this.settings.gridSize * this.currentImageSizeFactor
        },
        init: function() {
            var instance = this;
            instance.currentWidth = instance.$element.width();
            this.$element.find(this.settings.wrapperSelector).css({
                position: 'relative'
            });
            var hash = window.location.hash;
            this.$element.find(this.settings.wrapperSelector).css({
                position: 'relative',
                minWidth: instance.settings.minTileWidth
            });
            this.tiles = this.$element.find(this.settings.itemSelector).not('.hidden-tile');
            this.currentWidth = this.$element.width();
            if (this.settings.layout != 'columns' && this.settings.layout != 'rows' && this.settings.layout != 'final') {
                console.log("WARNING: unknown layout, falling back to 'final'.")
            }
            if (this.settings.layout == 'columns') {
                this.setCurrentColumnSize();
            }
            var _resizeTo = 0;
            this.setCurrentImageSizeFactor();
            this.setCurrentGridSize();
            $(window).resize(function() {
                _resizeTo = setTimeout(function() {
                    if (instance.currentWidth != instance.$element.width()) {
                        clearTimeout(_resizeTo);
                        instance.currentWidth = instance.$element.width();
                        instance.setCurrentColumnSize();
                        instance.setCurrentImageSizeFactor();
                        instance.setCurrentGridSize();
                        instance.refresh();
                    }
                }, 500);
            });
            instance.isLoading = true;
            this.edges.push({
                left: 0,
                top: 0,
                width: this.currentWidth,
                index: 0
            });
            this.loadImage();
        },
        refresh: function() {
            this._loadedImages = 0;
            this.loadImage();
        },
        nextTile: function(add) {
            var instance = this;
            if (add)
                instance.add(instance._loadedImages);
            if (++instance._loadedImages < instance.tiles.length) {
                instance.loadImage();
            } else {
                var height = instance.lowerEdgeTop();
                instance.$element.find(this.settings.wrapperSelector).height(height);
                instance.isLoading = false;
                instance.settings.onComplete();
            }
        },
        loadImage: function() {
            var instance = this;
            var $tile = this.tiles.eq(this._loadedImages);
            var $item = $tile.find('img');
            switch ($item.get(0).tagName.toLowerCase()) {
                case "img":
                    var img = new Image();
                    img.onload = function() {
                        var iFactor = instance.currentImageSizeFactor;
                        var size = {};

                        var addImage = true;
                        if (instance.settings.layout == "final") {
                            var w = $item.attr("width") ? parseInt($item.attr("width")) : img.width;
                            var h = $item.attr("height") ? parseInt($item.attr("height")) : img.height;
                            size.width = w * iFactor;
                            size.height = h * iFactor;
                        }
                        if (instance.settings.layout == "columns") {
                            size.width = instance._columnSize;
                            size.height = (size.width * img.height) / img.width;
                        }
                        $item.attr("src", this.src);
                        instance.imagesData["tile" + instance._loadedImages] = {
                            width: size.width,
                            height: size.height,
                            owidth: img.width,
                            oheight: img.height,
                            src: img.src
                        };
                        instance.nextTile(addImage);
                    }
                    img.onerror = function() {
                        instance.nextTile(true);
                    }
                    img.src = $item.attr("src");

                    break;
                default:
                    instance.imagesData["tile" + instance._loadedImages] = {
                        width: parseInt($item.data("width")),
                        height: parseInt($item.data("height")),
                        owidth: parseInt($item.data("width")),
                        oheight: parseInt($item.data("height"))
                    };
                    instance.nextTile(true);
                    break;
            }
        },
        add: function(tileIndex) {
            var $t = this.tiles.eq(tileIndex);
            var $item = $t.find('img');
            var key = "tile" + tileIndex;
            var w = this.imagesData[key].width;
            var h = this.imagesData[key].height;
            var hEdge = this.higherEdge();
            hEdge.tileIndex = tileIndex;

            if (hEdge.top > 0) {
                hEdge.top += this.settings.margin;
            }
            $t.css({
                left: hEdge.left,
                top: hEdge.top,
                position: 'absolute'
            });
            hEdge.enlarged = false;
            if (hEdge.width < w + this.settings.margin) {
                hEdge.case = 'Te';
                var w2 = hEdge.width;
                var h2 = (h / w) * w2;
                if (w2 + hEdge.left - this.settings.margin == this.currentWidth) {
                    w2 -= this.settings.margin;
                    h2 = (h / w) * w2;
                }
                w = w2;
                h = h2;
            } else if (hEdge.width > w) {
                if (this.settings.layout == 'columns' || hEdge.width - w >= this.settings.minTileWidth) {
                    hEdge.case = 'tE';
                    var newEdge = {
                        left: hEdge.left + w + this.settings.margin,
                        top: hEdge.top - (hEdge.top > 0 ? this.settings.margin : 0),
                        width: hEdge.width - w - this.settings.margin,
                        marginLeft: true,
                        case: 'NEW',
                        index: hEdge.index + 1
                    }
                    this.edges.push(newEdge);
                } else {
                    hEdge.case = 'tE2';
                    var m = hEdge.left + hEdge.width == this.currentWidth ? 0 : this.settings.margin;
                    var w2 = hEdge.width;
                    var h2 = this.settings.allowEnlargement && this.settings.layout != 'rows' ? (h / w) * w2 : h;
                    if (this.settings.allowEnlargement) {
                        $t.addClass("ftg-enlarged");
                        hEdge.enlarged = true;
                    } else {
                        if (this.settings.layout != 'rows')
                            $t.find("img").css({
                                width: w,
                                height: h
                            });
                    }
                    w = w2;
                    h = h2;
                }
            }
            hEdge.top += h;
            if (this.currentGridSize) {
                var diff = hEdge.top % this.currentGridSize;
                hEdge.top -= diff;
                h -= diff;
            }
            hEdge.left = hEdge.left;
            hEdge.width = w;
            var aligned = this.alignEdge(hEdge, tileIndex);
            if (aligned) {
                if (aligned.side == 'left') {
                    this.removeEdge(hEdge);
                    aligned.edge.width += w + this.settings.margin;
                    h = h - (hEdge.top - aligned.edge.top);
                    hEdge.top -= h;
                    printEdge = false;
                } else {
                    this.removeEdge(aligned.edge);
                    hEdge.width += this.settings.margin + aligned.edge.width;
                    printEdge = false;
                }
                $t.height(h);
            }
            if (this.$element.find(this.settings.wrapperSelector).height() < hEdge.top)
                this.$element.find(this.settings.wrapperSelector).height(hEdge.top);
            $t.css({
                width: w,
                height: h
            });
            var transition = $t.css('transition');
            $t.css({
                display: 'block',
                transform: 'scale(1)'
            });
            var ratio = w / this.imagesData[key].width;
            var hdiff = (this.imagesData[key].height * ratio) - h;
            if (hdiff > 0) {
                $item.css({
                    top: 0 - (hdiff / 2)
                });
            }
            $t.addClass("ftg-loaded");
        },
        alignEdge: function(edge, index) {
            for (var i = 0; i < this.edges.length; i++) {
                if (this.edges[i].left + this.edges[i].width + this.settings.margin == edge.left) {
                    if (edge.top == this.edges[i].top) {
                        return {
                            side: 'left',
                            edge: this.edges[i]
                        };
                    }
                }
            }
            for (var i = 0; i < this.edges.length; i++) {
                if (this.edges[i].left - this.settings.margin == edge.left + edge.width) {
                    if (edge.top == this.edges[i].top) {
                        return {
                            side: 'right',
                            edge: this.edges[i]
                        };
                    }
                }
            }
            return null;
        },
        lowerEdgeTop: function() {
            var min = 0;
            for (var i = 0; i < this.edges.length; i++) {
                if (this.edges[i].top > min) {
                    min = this.edges[i].top;
                }
            }
            return min;
        },
        higherEdge: function() {
            var left = 0;
            var _top = 100000;
            var _left = 0;
            var found = 0;
            for (var i = 0; i < this.edges.length; i++) {
                if (this.edges[i].top < _top) {
                    found = i;
                    _top = this.edges[i].top;
                }
            }
            return this.edges[found];
        },
        removeEdge: function(edge) {
            var tmp = [];
            for (var i = 0; i < this.edges.length; i++) {
                if (this.edges[i] != edge)
                    tmp.push(this.edges[i]);
            }
            this.edges = tmp;
        },
    });
    $.fn[pluginName] = function(options) {
        this.each(function() {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new Plugin(this, options));
            }
        });
        return this;
    };
})(jQuery, window, document);